import { START_LOADING, FINISH_LOADING } from "../actions/_actionType";

const initialState = {};

export default function rashLReducer(state = initialState, action) {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        [action.payload]: true, // 요청 시작
      };
    case FINISH_LOADING:
      return {
        ...state,
        [action.payload]: false, // 요청 시작
      };
    default:
      return state;
  }
}
